import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { LoyaltyProgramPageRoutingModule } from './loyalty-program-routing.module';

import { LoyaltyProgramPage } from './loyalty-program.page';
import {HomePageModule} from "../home/home.module";
import {SharedModule} from "../../shared/shared.module";

import {ProgramItemComponent} from "../../shared/components/program-item/program-item.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        LoyaltyProgramPageRoutingModule,
        SharedModule
    ],
  exports:[
    ProgramItemComponent
  ],
  declarations: [
    LoyaltyProgramPage,
    ProgramItemComponent
  ]
})
export class LoyaltyProgramPageModule {}
